import Box from '@mui/material/Box';
import React from 'react';

const EmojiReactions = ({ emoji }) => {
  return (
    <Box className="emojies-container">
      {[...Array(100)].map((idx) => {
        return React.cloneElement(emoji, { className: 'emoji-element' });
      })}
    </Box>
  );
};

export default EmojiReactions;
